export default __webpack_public_path__ + "static/media/visa-3.e92c1532.png";